/* Melea: выпадающее меню шапки открывается при наведении (только на
   устройствах с мышью; на тачскринах остаётся клик). Тема Taste/Dawn держит
   подменю в <details>, поэтому по hover переключаем атрибут open. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.header__inline-menu header-menu > details').forEach(function (details) {
    var closeTimer = null;

    details.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });

    /* небольшая задержка, чтобы меню не захлопывалось, когда курсор
       на мгновение выходит за край при движении к пункту подменю */
    details.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 150);
    });

    /* клик по заголовку с открытым меню ведёт как ссылка не должен —
       оставляем стандартное поведение details (закрыть/открыть) */
  });
})();
